export function createLegacyEventHub() {
    const listeners = new Map();

    return {
        $on(eventName, handler) {
            if (!listeners.has(eventName)) {
                listeners.set(eventName, new Set());
            }

            listeners.get(eventName).add(handler);
        },
        $off(eventName, handler) {
            const handlers = listeners.get(eventName);

            if (!handlers) {
                return;
            }

            handlers.delete(handler);

            if (handlers.size === 0) {
                listeners.delete(eventName);
            }
        },
        $emit(eventName, ...args) {
            const handlers = listeners.get(eventName);

            if (!handlers) {
                return;
            }

            for (const handler of handlers) {
                handler(...args);
            }
        },
    };
}
